'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FeatherAlertCircle } from '@subframe/core';
import { FeatherRotateCcw } from '@subframe/core';
import { Button } from '../Button';
import { EmptyState } from '../EmptyState';
import { Table } from '../Table';
import type { DataTableEmptyStateConfig, DataTableErrorStateConfig } from './types';
interface DataTableEmptyStateRowProps {
  colSpan: number;
  config: DataTableEmptyStateConfig;
}
export function DataTableEmptyStateRow(t0) {
  const $ = _c(8);
  const {
    colSpan,
    config
  } = t0;
  let t1;
  if ($[0] !== config.action || $[1] !== config.description || $[2] !== config.icon || $[3] !== config.title) {
    t1 = <EmptyState icon={config.icon} title={config.title} description={config.description} action={config.action} />;
    $[0] = config.action;
    $[1] = config.description;
    $[2] = config.icon;
    $[3] = config.title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== colSpan || $[6] !== t1) {
    t2 = <Table.Row><Table.Cell colSpan={colSpan} className="py-32">{t1}</Table.Cell></Table.Row>;
    $[5] = colSpan;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
interface DataTableErrorRowProps {
  colSpan: number;
  config: DataTableErrorStateConfig;
}
export function DataTableErrorRow(t0) {
  const $ = _c(13);
  const {
    colSpan,
    config
  } = t0;
  let t1;
  if ($[0] !== config.icon) {
    t1 = config.icon ?? <FeatherAlertCircle className="text-error-600" />;
    $[0] = config.icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = config.title ?? "Erro ao carregar dados";
  let t3;
  if ($[2] !== config.retryAction || $[3] !== config.retryLabel) {
    t3 = config.retryAction ? <Button variant="neutral-secondary" onClick={config.retryAction} icon={<FeatherRotateCcw />}>{config.retryLabel ?? "Tentar novamente"}</Button> : undefined;
    $[2] = config.retryAction;
    $[3] = config.retryLabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== config.description || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <EmptyState icon={t1} title={t2} description={config.description} action={t3} />;
    $[5] = config.description;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== colSpan || $[11] !== t4) {
    t5 = <Table.Row><Table.Cell colSpan={colSpan} className="py-32">{t4}</Table.Cell></Table.Row>;
    $[10] = colSpan;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}